import React from 'react';
var SnippylyHuddleTool = function (props) {
    var type = props.type, children = props.children, darkMode = props.darkMode;
    return (React.createElement("velt-huddle-tool", { type: type, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};
export default SnippylyHuddleTool;
